export const AccessibilityAlt = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 13H23" stroke="currentColor" stroke-width="2"/>
<path d="M21 24L17 17" stroke="currentColor" stroke-width="2"/>
<path d="M11 24L15 17" stroke="currentColor" stroke-width="2"/>
<path d="M17 17H15V13H17V17Z" stroke="currentColor" stroke-width="2"/>
<circle cx="16" cy="9" r="1.5" fill="currentColor" stroke="currentColor"/>
<circle cx="16" cy="16" r="13" stroke="currentColor" stroke-width="2"/>
</svg>`;
